import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AuthorizeValidateResult {
    valid: boolean;
    /** Set when valid is false. */
    reason?: 'unknown_client' | 'redirect_uri_not_registered' | 'invalid_scope';
    /** Set when valid is true. */
    clientName?: string;
    scopes?: string[];
    consented?: boolean;
    newScopes?: string[];
}

export interface AuthorizeRequestParams {
    clientId: string;
    redirectUri: string;
    scope: string;
    state: string;
    codeChallenge: string;
    codeChallengeMethod: string;
}

@Injectable({ providedIn: 'root' })
export class OAuthAuthorizeService {
    private readonly endpoint = `${environment.modeso.apiGateway}oauth/authorize`;

    public constructor(private readonly http: HttpClient) {}

    public validate(params: AuthorizeRequestParams): Observable<AuthorizeValidateResult> {
        const query = new HttpParams()
            .set('clientId', params.clientId)
            .set('redirectUri', params.redirectUri)
            .set('scope', params.scope);
        return this.http.get<AuthorizeValidateResult>(`${this.endpoint}/validate`, { params: query });
    }

    public approveAndMint(params: AuthorizeRequestParams): Observable<{ redirectTo: string }> {
        return this.http.post<{ redirectTo: string }>(this.endpoint, params);
    }
}
